import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import { useDispatchAction } from "../../../../../redux/store.hooks";
import { upsertAudienceListColumnAsync } from "../../../../../redux/marketCampaign/marketCampaignActions";
import { IAudienceListColumn } from "../../../../../redux/marketCampaign/marketCampaign.types";
import { Dialog } from "../../../../../components/Dialogs/Dialog";
import { useBillingCompanyContext } from "../../../../../providers";

interface ICreateNewHeaderDialogProps {
  open: boolean;
  onClose: () => void;
  onSuccess: (newColumn: string) => void;
}

export const CreateNewHeaderDialog: React.FC<ICreateNewHeaderDialogProps> = ({
  onClose,
  onSuccess,
  open,
}) => {
  const dispatch = useDispatchAction();
  const companyOutlet = useBillingCompanyContext();

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setValues,
    setFieldValue,
    handleBlur,
  } = useFormik({
    initialValues: {
      column: "",
    },
    validate: (values) => {
      const errors: any = {};
      if (!values.column) {
        errors.column = "This field is required";
      }
      return errors;
    },
    onSubmit: async (values) => {
      dispatch(
        upsertAudienceListColumnAsync(
          values.column,
          companyOutlet.comapny.company_outlet_uuid,
          (updatedData) => {
            onSuccess(values.column);
          }
        )
      );
    },
  });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Create New Header"
      size="md"
      contentWrappedWithForm={{ onSubmit: handleSubmit }}
      actions={[
        {
          variant: "outlined",
          label: "Cancel",
          type: "button",
          onClick: onClose,
        },
        {
          variant: "contained",
          label: "Create",
          type: "submit",
        },
      ]}
    >
      <Typography variant="subtitle2" sx={{ mb: 2 }}>
        Header Name
      </Typography>
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <TextField
          id="column"
          size="small"
          placeholder="Enter header name"
          value={values.column}
          onChange={handleChange}
          onBlur={(e) => {
            setFieldValue("column", e.target.value.trim());
          }}
          sx={{ flexGrow: 1 }}
          error={!!errors.column}
          helperText={errors.column}
        />
      </Box>
    </Dialog>
  );
};
